import { useRouter } from "next/router"
import React, { useMemo } from "react"

import { useTranslation } from "@bounce/i18n"
import { PostList } from "@bounce/web-components"

import { Topics } from "./Topics"
import type { FormattedBlogPostPreview } from "@/libs/prismic/types"
import { blogPostToPostCard, blogPostIncludes } from "@/utils/blogPost"

type Props = {
  articleData: FormattedBlogPostPreview[]
}

export const Posts = ({ articleData }: Props) => {
  const { t } = useTranslation("marketing-generic")
  const router = useRouter()
  const query = router.query.q?.toString() ?? ""

  const posts = useMemo(
    () => articleData.filter(post => blogPostIncludes(post, query)).map(blogPostToPostCard),
    [articleData, query],
  )

  return (
    <PostList
      title={t("screen.blog.listTitle", "Most recent")}
      headerRight={<Topics />}
      className="my-section"
      items={posts}
    />
  )
}
